/**
 * Global command-palette open/close state.
 *
 * Lives in a Zustand store so any feature anywhere in the tree can call
 * `openCommandPalette()` (e.g. from a top-bar badge button, an empty-state
 * CTA, or a keyboard shortcut hook) without prop-drilling or context.
 */
import { create } from 'zustand';

interface CommandPaletteState {
  isOpen: boolean;
  open(): void;
  close(): void;
  toggle(): void;
}

export const useCommandPaletteStore = create<CommandPaletteState>()((set) => ({
  isOpen: false,
  open() {
    set({ isOpen: true });
  },
  close() {
    set({ isOpen: false });
  },
  toggle() {
    set((s) => ({ isOpen: !s.isOpen }));
  },
}));

/** Imperative helper for callers outside React (event handlers, route guards). */
export function openCommandPalette(): void {
  useCommandPaletteStore.getState().open();
}

/** Imperative helper to close from outside React. */
export function closeCommandPalette(): void {
  useCommandPaletteStore.getState().close();
}
